export default __webpack_public_path__ + "static/media/project23.ce34f1f1.jpg";